import { useCallback, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Typography, Button } from "@mui/material";
import PropTypes from "prop-types";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

function DragDropZone({ onDrop, label, required, imagePreview }) {
  const [firstClick, setFirstClick] = useState(false); // Chỉ dùng khi chưa có ảnh
  const timerRef = useRef(null);

  const handleDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onDrop(acceptedFiles[0]);
        setFirstClick(false); // reset sau khi chọn ảnh
      }
    },
    [onDrop]
  );

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop: handleDrop,
    accept: { "image/*": [] },
    noClick: true,
    noKeyboard: true,
    multiple: false,
  });

  const handleZoneClick = () => {
    if (imagePreview) {
      // Có ảnh: 1 click là mở
      open();
    } else {
      // Chưa có ảnh: click 2 lần mới mở
      if (firstClick) {
        open();
        setFirstClick(false);
        clearTimeout(timerRef.current);
      } else {
        setFirstClick(true);
        timerRef.current = setTimeout(() => setFirstClick(false), 1000); // reset nếu không bấm lần 2 trong 1s
      }
    }
  };

  return (
    <Box>
      <Typography fontWeight="bold" fontSize="16px" mb={0.5} color="text.primary">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Typography>

      <Box
        {...getRootProps()}
        sx={{
          border: "2px dashed #ccc",
          borderRadius: "8px",
          minHeight: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          cursor: "pointer",
          bgcolor: isDragActive ? "#f0f8ff" : "#fafafa",
          overflow: "hidden",
          position: "relative",
          textAlign: "center",
          p: 2,
        }}
        onClick={handleZoneClick}
      >
        <input {...getInputProps()} />
        {imagePreview ? (
          <Box
            component="img"
            src={
              typeof imagePreview === "string" ? imagePreview : URL.createObjectURL(imagePreview)
            }
            sx={{
              maxHeight: 200,
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        ) : (
          <>
            <CloudUploadIcon fontSize="large" sx={{ color: "#888", mb: 1 }} />
            <Typography fontSize="14px" color="text.secondary" mb={1}>
              Kéo thả hoặc nhấp để tải lên
            </Typography>
            {/* <Typography fontSize="12px" color="text.secondary" mb={1}>
              SVG, PNG, JPG hoặc GIF
            </Typography> */}
            <Button
              variant="outlined"
              sx={{ border: "gray 1px solid", color: "black !important" }}
              onClick={(e) => {
                e.stopPropagation(); // ngăn click vào vùng chính
                open();
              }}
            >
              Chọn tệp
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}

DragDropZone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  imagePreview: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]),
};

DragDropZone.defaultProps = {
  label: "",
  required: false,
  imagePreview: null,
};

export default DragDropZone;
